"use strict";

exports.__esModule = true;
exports.formatDimension = formatDimension;

var _formatValue = require("./formatValue");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function formatDimension(col, language = "nb") {
  const dimension = col.dimension,
        type = col.type,
        value = col.value;
  let formattedValue = value;

  if (dimension === "ga:date") {
    formattedValue = (0, _formatValue.formatValue)(value, "DATE");
  }

  return _extends({}, col, {
    formattedValue: formattedValue
  });
}